(function () {
    'use strict';

    angular
        .module('app')
        .controller('viewer', viewer);

    viewer.$inject = ['$scope', '$window', '$stateParams', '$mdDialog', 'loginService', 'optionsService', '$location', 'viewerService'];

    function viewer($scope, $window, $stateParams, $mdDialog, loginService, optionsService, $location, viewerService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'viewer';
        vm.loginService = loginService;

        var items = [];
        items.push(JSON.parse($stateParams.fileInfo));
        var slx = { mode: 0, order: 0, list: items };



        //get the viewer options
        optionsService.getViewerOptions().then(function (viewerOptions) {
            console.log("got viewer options");
            viewerService.canPrint(slx.list[0].fileId).then(function (canPrint) {
                var fileId = slx.list[0].fileId;
                var loginName = slx.list[0].loginName;
                var xjvueserver = viewerOptions.jVueServer;
                var guifile = canPrint ? 'AdeptConvertPrintRedline.gui' : 'viewonly.gui';
                var xdms = viewerOptions.dms;
                var language = 'en';
                var xcodebase = viewerOptions.codebase;
                var hperc = '99';//slx.list[0].userName.hperc;
                var documentString = 'TableNumber=' + slx.list[0].tableNumber + ':';
                documentString += 'FileId=' + fileId + ':';
                documentString += 'MinRev=' + slx.list[0].minRev + ':';
                documentString += 'MajRev=' + slx.list[0].majRev + ':';
                documentString += 'FileNE=' + slx.list[0].filename + ':';
                documentString += 'Size=' + slx.list[0].size + ':';
                documentString += 'IsParent=' + slx.list[0].isParent + ':';
                documentString += 'LoginName=' + slx.list[0].loginName + ':';
                documentString += 'UserName=' + slx.list[0].userName + ':';
                //var fileDate = slx.list[0].fileUtc;
                //var fileDate = (fileDate.getMonth() + 1) + '/' + fileDate.getDate() + '/' + fileDate.getFullYear();
                //documentString += 'Date=' + (fileDate.getMonth() + 1) + '/' + fileDate.getDate() + '/' + fileDate.getFullYear() + ':';

                vm.docId = documentString;

                var jVuePage =
                    '<APPLET\n' +
                    'NAME="JVue"\n' +
                    'CODE="com.cimmetry.jvue.JVue.class"\n' +
                    'CODEBASE="' + xcodebase + '"\n' +
                    'ARCHIVE="jvue.jar,jogl.jar,gluegen-rt.jar"\n' +
                    'HSPACE="0" VSPACE="0"\n' +
                    'WIDTH="100%" HEIGHT= "' + hperc + '%"    MAYSCRIPT>\n' +
                    '<PARAM NAME="EMBEDDED"         VALUE="true">\n' +
                    '<PARAM NAME="VERBOSE"          VALUE="false">\n' +
                    '<PARAM NAME="GUIFILE"          VALUE="' + guifile + '">\n' +
                    '<PARAM NAME="HEAVYWEIGHT"      VALUE="FALSE">\n' +
                    '<PARAM NAME="FILENAME"         VALUE="' + documentString + '">\n' +
                    '<PARAM NAME="JVUESERVER"       VALUE="' + xjvueserver + '">\n' +
                    '<PARAM NAME="DMS"              VALUE="' + xdms + '">\n' +
                    '<PARAM NAME="USERNAME"         VALUE="' + slx.list[0].userName + '">\n' +
                    '<PARAM NAME="DMSARGS"          VALUE="USERNAME;DMS_PRESERVE_COOKIES;">\n' +
                    '<PARAM NAME="DMS_PRESERVE_COOKIES" VALUE="TRUE">\n' +
                    '<PARAM NAME="LOCALE"           VALUE="' + language + '">\n' +
                    '<p><b>Requires a browser that supports Java.</b></p>\n' +
                    '</APPLET>\n';
                // Inject applet code into the document.  This is needed because
                // the variables in AngularJS are not available right away, which is
                // necessary for the applet code to load.
                document.getElementById("viewAppletContainer").innerHTML = jVuePage;

                // Start the SignalR connection
                console.log("viewerService.startSignalR");
                viewerService.startSignalR(fileId).then(function () {
                });
            });
            
        }, function (response) {
            scope.message = 'Missing viewer configuration.  Please log out, and then log in again.';
            var errorMsgId = 'VIEW_BROWSER_CONFIGURATION_MISSING';
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/selectioncommand/templates/viewError.html',
                controller: 'viewError',
                fullscreen: false,
                locals: {
                    errorMsgId: errorMsgId,
                    errorMsg: ''
                }
            });
        });



    }
})();
